import {BaseResponseType, DataGridRequest, PagedResponseType, WorkFlowTaskRequest} from "../shared-models/sharedTypes";
import {HttpClient} from "../../helpers";

export const WorkFlowService = {
    WorkflowAction: async (courseOrderId: number, request : WorkFlowTaskRequest) => {
        return await HttpClient.put<BaseResponseType<boolean>>(`/api/Workflow/WorkflowAction/${courseOrderId}`, request);
    },
    getAllWorkflowProcess: async (request: DataGridRequest) => {
        return await HttpClient.post<PagedResponseType<any>>(`/api/Workflow/GetAllWorkflowProcess`, request);
    }
}
